export enum NotificationType {
  Info = 'toast toast-info show',
  Success = 'toast toast-success show',
  Warning = 'toast toast-warning show',
  Error = 'toast toast-error show'
}
